import { 
    BlockText, 
    BlockMedia, 
    BlockPullQuote, 
    BlockHeading, 
    BlockSectionOpening, 
    BlockCarousel, 
    BlockVideoPlayer, 
    BlockTextMedia, 
    BlockCaseStudy, 
    BlockRecentProjects, 
    BlockJournal,
    BlockContact,
    BlockSignUp
} from './templates'

export const resolveBlock = (layout) => {
    let block;

    // Map layout strings to blocks

    const blocks = {
        'paragraph': BlockText,
        'media': BlockMedia,
        'pull_quote': BlockPullQuote,
        'carousel': BlockCarousel,
        'heading': BlockHeading,
        'section_opening': BlockSectionOpening,
        'video_player': BlockVideoPlayer,
        'text_and_media': BlockTextMedia,
        'case_study': BlockCaseStudy,
        'recent_projects': BlockRecentProjects,
        'journal_posts': BlockJournal,
        'contact': BlockContact,
        'sign_up': BlockSignUp
    }
    
    return blocks[layout]
}

// Carousel Animation

export const parentHasClass = (element, classname) => {
    if (element.className) {
        if (element.className.split(' ').indexOf(classname)>=0) return true;
        return element.parentNode && parentHasClass(element.parentNode, classname);
    } else {
        return element.parentNode && parentHasClass(element.parentNode, classname);
    }
}

export const getActiveSlide = (nodes) => {
    for (let node of nodes) {
        if (parentHasClass(node, 'slick-active')) {
            return node
        }	
    }
}

export const resetAnimation = (node) => {
    if (node) {
        node.style.transform = '';
        node.style.width = '';
        node.style.height = '';
        node.classList.remove('animate');
    }
}

export const transitionElement = (from, to) => {
    
    // Reset animation values on to 

    resetAnimation(to)

    // Allow incoming node to animate

    from.classList.add('animate');

    // console.log(from, to)
    console.log(from.getBoundingClientRect(), to.getBoundingClientRect())

    const verticalTravelDistance = from.getBoundingClientRect().top - to.getBoundingClientRect().top;
    // const widthScale = to.getBoundingClientRect().width / from.getBoundingClientRect().width;
    // const heightScale = to.getBoundingClientRect().height / from.getBoundingClientRect().height;
    const horizontalTravelDistance = from.getBoundingClientRect().left - to.getBoundingClientRect().left;

    window.requestAnimationFrame(() => {
        // Initial values

        from.style.width = `${from.getBoundingClientRect().width}px`;
        from.style.height = `${from.getBoundingClientRect().height}px`;

        // Transition values

        from.style.transform = `translateY(${-verticalTravelDistance}px) translateX(${-horizontalTravelDistance}px)`;
        from.style.width = `${to.getBoundingClientRect().width}px`;
        from.style.height = `${to.getBoundingClientRect().height}px`;
    });
}




// WEBPACK FOOTER //
// ./src/components/Block/utils.js